module.exports = __webpack_public_path__ + "img/96.05bb9eb8.jpg";